<template>
  <div>
    <h3 class="text-xl mb-6">General Information</h3>
    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/2 pr-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="first_name" class="block text-xs mb-2">First Name<span class="text-primary">*</span></label>
          <input type="text" id="first_name" v-model="order.first_name" class="input w-full bg-white text-grey-darkest" tabindex="1">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('first_name')" v-text="errorBag.get('first_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="location" class="block text-xs mb-2">Location<span class="text-primary">*</span></label>
          <input type="text" id="location" v-model="order.location" class="input w-full bg-white text-grey-darkest" tabindex="3">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('location')" v-text="errorBag.get('location')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="email_address" class="block text-xs mb-2">Email Address<span class="text-primary">*</span></label>
          <input type="text" id="email_address" v-model="order.email" class="input w-full bg-white text-grey-darkest" tabindex="5">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('email')" v-text="errorBag.get('email')"></small>
        </div>
      </div>
      <div class="w-full md:w-1/2 pl-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="last_name" class="block text-xs mb-2">Last Name<span class="text-primary">*</span></label>
          <input type="text" id="last_name" v-model="order.last_name" class="input w-full bg-white text-grey-darkest" tabindex="2">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('last_name')" v-text="errorBag.get('last_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="dietary_requirements" class="block text-xs mb-2">Dietary Requirements<span class="text-primary">*</span></label>
          <input type="text" id="dietary_requirements" v-model="order.dietary_requirements" class="input w-full bg-white text-grey-darkest" tabindex="4">
          <small class="block text-primary text-medium mt-2" v-if="errorBag.get('dietary_requirements')" v-text="errorBag.get('dietary_requirements')"></small>
        </div>
      </div>
    </div>
    <div class="w-full mb-8">
      <div class="w-full block mb-4">
        <div class="inline-block pr-2"><input type="radio" id="ticket" class="align-middle cursor-pointer" v-model="order.conference_id" :value="conference.id" checked="checked" /></div>
        <label for="ticket" class="text-sm align-middle cursor-pointer">{{ conference.name }}</label>
      </div>
      <small class="block text-primary text-medium mt-2" v-if="errorBag.get('ticket_id')" v-text="errorBag.get('ticket_id')"></small>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['conference', 'tickets', 'order', 'errorBag']
}
</script>
